import { render, staticRenderFns } from "./LoginPageSetting.vue?vue&type=template&id=6ecd4aa8&scoped=true&lang=pug"
import script from "./LoginPageSetting.vue?vue&type=script&lang=js"
export * from "./LoginPageSetting.vue?vue&type=script&lang=js"
import style0 from "./LoginPageSetting.vue?vue&type=style&index=0&id=6ecd4aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd4aa8",
  null
  
)

export default component.exports